"use client";

import { useState, useEffect } from "react";
import { usePathname } from "next/navigation";
import Link from "next/link";
import Image from "next/image";

export default function StickyBanner({ programs }) {
  const [isVisible, setIsVisible] = useState(false);
  const [programData, setProgramData] = useState(null);
  const pathname = usePathname();

  useEffect(() => {
    // Extract slug from pathname
    const slug = pathname.split("/").pop();

    // Find matching program
    const matchingProgram = programs.find((program) => program.slug === slug);

    if (matchingProgram) {
      setProgramData(matchingProgram);
    } else if (programs.length > 0) {
      // Fallback to first program if no match found
      setProgramData(programs[0]);
    }

    // Show banner after scrolling
    const handleScroll = () => {
      // Show after scrolling 300px
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [pathname, programs]);

  if (!programData) {
    return null;
  }

  return (
    <div
      className={`fixed bottom-0 left-0 w-full bg-[#fffaf1] border-t border-gray-200 py-4 transition-transform duration-300 z-50 ${
        isVisible ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <div className="w-[90%] md:w-[80%] mx-auto flex flex-col-reverse gap-2 md:flex-row items-center justify-between">
        <div>
          <h3 className="hidden md:block text-[#002726] text-xl font-medium mb-2 md:mb-0">
            {programData.sticky}
          </h3>
          <Link
            href="/b2b"
            className="text-[#002726] underline text-sm font-medium"
          >
            Looking for your team?
          </Link>
        </div>

        <div className="flex items-center mt-4 md:mt-0 space-x-3">
          
 <Link
            href={programData.applyLink}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center px-6 py-3 bg-[#33c375]  rounded-lg hover:bg-[#43a047] transition-colors"
          >
            Join the Waitlist
          </Link>

          <Link
            href={programData.brochureLink}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center px-6 py-3 border border-[#002726] rounded-lg hover:bg-gray-50 transition-colors"
          >
            <Image
              className="object-cover w-full h-full"
              src="https://d31bwppm8yl9g2.cloudfront.net/learner/website/dwar.svg"
              alt="grid"
              width={10}
              height={10}
              priority
            />
            Brochure
          </Link>

         
        </div>
      </div>
    </div>
  );
}
